import {
  documentToHtmlString,
  type Options as HtmlOptions,
} from '@contentful/rich-text-html-renderer'
import { documentToReactComponents, type Options } from '@contentful/rich-text-react-renderer'
import { BLOCKS, INLINES, type Inline, type Block } from '@contentful/rich-text-types'
import type { Document } from '@contentful/rich-text-types'

import { InlineEmbeddedEntry } from './inline-embedded-entry'
import { InlineLink } from './inline-link'
import { ListItem } from './list-item'
import { OlList } from './ol-list'
import { UlList } from './ul-list'

export const renderRichTextSingleLineContent = (richText: Document) => {
  return renderRichText(richText, {
    [BLOCKS.PARAGRAPH]: (_, children) => <>{children}</>,
  })
}

export const renderRichText = (richText: Document, renderNodeOptions?: Options['renderNode']) => {
  return documentToReactComponents(richText, {
    renderNode: {
      ...renderNodeOptions,
      [INLINES.HYPERLINK]: (node, children) => (
        <InlineLink {...(node as Inline)}>{children}</InlineLink>
      ),
      [INLINES.EMBEDDED_ENTRY]: node => <InlineEmbeddedEntry {...(node as Inline)} />,
      [BLOCKS.UL_LIST]: (node, children) => <UlList {...(node as Block)}>{children}</UlList>,
      [BLOCKS.OL_LIST]: (node, children) => <OlList {...(node as Block)}>{children}</OlList>,
      [BLOCKS.LIST_ITEM]: (node, children) => <ListItem {...(node as Block)}>{children}</ListItem>,
    },
  })
}

export const renderRichTextMultiLineContent = (richText: Document) => {
  return renderRichText(richText, {
    [BLOCKS.PARAGRAPH]: (_, children) => (
      <>
        {children}
        <br />
      </>
    ),
  })
}

/**
 *
 * @param richText
 * @param renderNodeOptions
 * @param ContextProvider since this function uses React's `renderToString()` function which loses any Context around it, we need to pass the Context Provider of the Context we want to preserve so that we can re-create it within the `renderToString()` call
 * @param contextValue  the corresponding value of the Context we want to preserve
 */
export const renderRichTextToHtmlString = (
  richText: Document,
  renderNodeOptions?: HtmlOptions['renderNode'],
): string => {
  return documentToHtmlString(richText, {
    renderNode: {
      ...renderNodeOptions,
    },
  })
}
